import React from "react"
import { Control } from "react-hook-form"
import { Box, FormLabel } from "@chakra-ui/react"
import TextField from "components/ReactHookForm/TextField"
import TextArea from "components/ReactHookForm/TextArea"

type Props = {
  control: Control<object, any>
}

// Groups the Name input and Description textarea under a single
// "Name and Description" label, per the redesigned form modal.
const NameAndDescription = ({ control }: Props) => (
  <Box>
    <FormLabel fontWeight="semibold" mb={2}>Name and Description</FormLabel>
    <TextField
      name="name"
      control={control}
      ariaLabel="Name"
      variant="outline"
      vertical
      mb={3}
    />
    <TextArea
      name="description"
      control={control}
      ariaLabel="Description"
      vertical
      placeholder="Description (optional)"
      helperText="The form name and description will appear on the Guest Portal and receipt."
    />
  </Box>
)

export default NameAndDescription
